import { render, staticRenderFns } from "./BCODashboard.vue?vue&type=template&id=5e73ea10&scoped=true&"
import script from "./BCODashboard.vue?vue&type=script&lang=js&"
export * from "./BCODashboard.vue?vue&type=script&lang=js&"
import style0 from "./BCODashboard.vue?vue&type=style&index=0&id=5e73ea10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e73ea10",
  null
  
)

export default component.exports